import { ApiError } from '../lib/api'
import { MAX_DESIGN_NAME } from '../lib/copyName'
import type { LayoutKind } from './types'

export type NameProblem = 'required' | 'tooLong' | 'taken'

/** What is wrong with naming design self this, as the server would judge it, or null. */
export function nameProblem(
  name: string,
  kind: LayoutKind,
  designs: ReadonlyArray<{ id: string; kind: LayoutKind; name?: string }>,
  self: string,
): NameProblem | null {
  const trimmed = name.trim()
  if (trimmed === '') return 'required'
  if ([...trimmed].length > MAX_DESIGN_NAME) return 'tooLong'
  const lower = trimmed.toLowerCase()
  if (designs.some((d) => d.id !== self && d.kind === kind && (d.name ?? '').trim().toLowerCase() === lower)) return 'taken'
  return null
}

/** What a picture delete's answer asks for next: nothing, a second confirm naming the old versions, or a refusal to show. */
export function pictureDeleteNext(err: unknown): { step: 'done' } | { step: 'versions'; n: number } | { step: 'refused' } {
  if (err === null) return { step: 'done' }
  if (err instanceof ApiError && err.code === 'IN_OLD_VERSIONS') return { step: 'versions', n: Number(err.args?.n) || 0 }
  return { step: 'refused' }
}
